import { messageIdProvider, registerTranslationDivisions } from "infrastructure/localization";

export const displayDivision = "display";

registerTranslationDivisions([displayDivision]);

export const displayMessages = messageIdProvider(displayDivision);
